import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HowItWorks.css';
import Button from '../ui/Button';
import missouriLandscape from '../../assets/images/missouri-landscape.png';
import missouriPattern from '../../assets/images/missouri-pattern.png';
import missouriShirt from '../../assets/images/missouri-shirt.png';

const HowItWorks = () => {
  const navigate = useNavigate();

  const handleStartDesigning = () => {
    navigate('/design');
  };

  return (
    <section className="how-it-works">
      <h2>How It Works</h2>
      <p className="contest-info">
        Cult Camo holds monthly contests to select a pattern that will be sold on our platform. The community votes on whose design they like the most. We must hit 1,000 community members before selling.
      </p>
      <div className="steps">
        <div className="step">
          <div className="step-number">1</div>
          <h3>Upload</h3>
          <p>Share your environment photo</p>
          <img src={missouriLandscape} alt="Missouri landscape example" className="howitworks-img" />
        </div>
        <div className="step">
          <div className="step-number">2</div>
          <h3>Design</h3>
          <p>Create your custom pattern</p>
          <img src={missouriPattern} alt="Missouri camo pattern example" className="howitworks-img" />
        </div>
        <div className="step">
          <div className="step-number">3</div>
          <h3>Submit</h3>
          <p>Put your design in the monthly contest</p>
          <img src={missouriShirt} alt="Shirt with Missouri camo pattern" className="howitworks-img" />
        </div>
      </div>
      <div className="cta-container">
        <Button variant="primary" onClick={handleStartDesigning}>Start Designing</Button>
      </div>
    </section>
  );
};

export default HowItWorks; 